module.exports = __webpack_public_path__ + "img/81.0c567d60.jpg";